import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-input__container" }
const _hoisted_2 = { class: "text-input__label" }
const _hoisted_3 = { class: "text-input__label-text" }

import { ref, watch, computed, StyleValue } from 'vue';
import NumberInputWithComma from '@/corePagesModule/components/NumberInputWithComma.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberInput',
  props: {
    modelValue: {},
    placeholder: {},
    label: {},
    disabled: { type: Boolean },
    hasBorder: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const value = ref(props.modelValue);

/**
 * テキスト入力の値が変更されたときに呼び出されるハンドラ
 * @param value - 変更された値
 */
const onInput = (value: string) => {
  emits('update:modelValue', Number(value));
};

/**
 * テキスト入力の値を更新します。
 * @param value - 更新する値
 */
const updateAmount = (value: number) => {
  emits('update:modelValue', value);
};

watch(
  () => props.modelValue,
  () => {
    value.value = props.modelValue;
  }
);

watch(
  () => value.value,
  () => {
    emits('update:modelValue', value.value);
  }
);

const inputBorderStyle = computed((): StyleValue => {
  return props.hasBorder ? { border: '1px solid #212121', borderRadius: '4px', overflow: 'hidden' } : {};
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.label), 1)
    ]),
    _createElementVNode("div", {
      class: "text-input",
      style: _normalizeStyle(inputBorderStyle.value)
    }, [
      _createVNode(NumberInputWithComma, {
        class: "text-input__body",
        placeholder: props.placeholder,
        disabled: props.disabled,
        "model-value": props.modelValue,
        "onUpdate:modelValue": updateAmount,
        onInput: onInput
      }, null, 8, ["placeholder", "disabled", "model-value"])
    ], 4)
  ]))
}
}

})